document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector('.jsAccordion')){
        const jsAccordions = document.querySelectorAll('.jsAccordion');
    
        for (let index = 0; index < jsAccordions.length; index++) {
            let item = jsAccordions[index];
            let trigger = item.querySelector('.jsAccordionTrigger');
            let body = item.querySelector('.jsAccordionBody');
            let content = item.querySelector('.jsAccordionContent');
    
            check()
            
            trigger.addEventListener('click', function(){
                item.classList.toggle('is-active');
                check()
            })
            
            function check(){
                if(item.classList.contains('is-active')){
                    body.style.height = content.offsetHeight + 'px';
                } else {
                    body.style.height = '';
                }
            }
        }
    }
})